<template>
  <div class="progress-bar" :style="hrMargin">
    <div class="time-bar" :style="{'width': `${precentage}%`}"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'QuestionTimer',
  data() {
    return {
      progress: 0,
      precentage: 100,
      questionTimer: null,
    };
  },
  computed:{
    ...mapGetters([
       'textColor', 'primaryColor'
    ]),
    hrMargin(){
      return{
         "background-color": this.primaryColor
      }
    },

  },
  props: ['qduration'],
  methods: {
    timer(duration) {
      this.progress = duration * 1000;
      this.questionTimer = setInterval(() => {
        this.precentage = Math.floor((this.progress * 100) / (duration * 1000));
        this.progress -= 100;
        if (this.progress === 0) {
          this.precentage = 0;
          clearInterval(this.questionTimer);
        }
      }, 100);
    },
  },
  watch: {
    qduration(newValue) {
      this.precentage = 100;
      this.progress = 0;
      clearInterval(this.questionTimer);
      this.timer(newValue.timelimit);
    },

  },
  mounted() {
    this.precentage = 100;
    this.progress = 0;
    this.timer(this.qduration.timelimit);
  },
};
</script>

<style lang="scss" scoped>
.progress-bar {
  background-color: $nebula;
  border-radius: 25px;
  margin: 0rem;
  height: 4px;
}
.time-bar {
  border-radius: 25px;
  margin: 0rem;
  height: 4px;
  background-color: lavender;
  
}
</style>
